import CopyReferralCode from './CopyReferralCode';

export default CopyReferralCode;
